<template>
<div class="qualityenterprise" v-title data-title="产业招商大脑-创新企业">
	<leftnav class=" fl" :curindex="curindex":activenav='"1-4"' :openmeun='true' :openmeunclass='3'></leftnav>
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">
			<div class="whitebox right_topbox">
				<div class="right_boxtitle">
					<span class="fl right_title">企业</span>
					<div class="fl search-box nz-search-box">
						<input type="text" placeholder="检索创新企业库" class="" v-model="searchtext" @keydown="searchenter"/>
						<button class="" @click="searchkwfun">查询</button>
					</div>
				</div>
				<div>
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl">
								<span :class="searchtype == 9?'a-screen current':'a-screen'" @click="routerself('/qualityenterprise9?type=10')">上市企业</span>
								<span :class="searchtype == 1?'a-screen current':'a-screen'" @click="routerself('/qualityenterprise1?type=2')">龙头企业</span>
								<span :class="searchtype == 2?'a-screen current':'a-screen'" @click="routerself('/qualityenterprise2?type=3')">创新企业</span>
								<span :class="searchtype == 3?'a-screen current':'a-screen'"  @click="routerself('/qualityenterprise3?type=4')">优质企业</span>
								<span :class="searchtype == 0?'a-screen current':'a-screen'" @click="routerself('/allsearch?type=1')">全部企业</span>
								<el-tooltip class="item smartTip-text" effect="light"  placement="top-start">
								       <i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
															<div   slot="content" class="list_tips">
																<p>上市企业：行业内重点的上市企业</p>
																<p>龙头企业：行业内领先的标杆企业</p>
																<p>创新企业：有融资记录的企业</p>
																<p>优质企业：有一定实力的企业</p>
																</div> 
								    </el-tooltip>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="searchtype==2" >
								<dt class="fl">融资轮次</dt>
								<dd class="fl"> 
									<span v-for="(item,index) in qyslitag2"
										@click="searchtagdata[1]=item.tagCode;ajaxsearchcompany(1,'tags')"
										:class="searchtagdata[1] == item.tagCode ?'a-screen current' : 'a-screen'">{{item.tagName}}</span>
								</dd>
							</dl> 
							<dl class="opport-screen bdbe">
								<dt class="fl">科技实力</dt>
								<dd class="fl"> 
									<span v-for="(item,index) in qyslitag"
										@click="searchtagdata[0]=item.tagCode;ajaxsearchcompany(1,'tags')"
										:class="searchtagdata[0] == item.tagCode ?'a-screen current' : 'a-screen'">{{item.tagName}}</span>
								</dd>
							</dl> 
							
						</div>
						<dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl">
								<span :class="provinceid == 0?'current a-screen':'a-screen'"
									@click="provincechoose(0,'all');userdata.provinceText='全国地区' ">全国地区</span>
								<span v-for="(item,index) in provincedata"
									@click="provincechoose(item.areaId,index);userdata.provinceText=item.areaName"
									:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length!=0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<span :class="cityid == 0?'current a-screen':'a-screen'"
									@click="choosecity(0,'all');userdata.cityText=''">全部</span>
								<span v-for="(item,index) in citydata"
									@click="choosecity(item.areaId,index);cityid=item.areaId;userdata.cityText=item.name"
									:data="item.areaId"
									:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length!=0">
							<dt class="fl">区县地区</dt>
							<dd class="fl">
								<span :class="countyid == 0?'current a-screen':'a-screen'"
									@click="choosecounty(0);userdata.countyText=''">全部</span>
								<span v-for="(item,index) in countydata"
									@click="choosecounty(item.areaId);countyid=item.areaId;userdata.countyText=item.name"
									:data="item.areaId"
									:class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-if="initialTagdata.length!=0">
							<dt class="fl">画像标签</dt>
							<dd class="fl">
							 <div class="selecttag" v-for="(list,index) in initialTagdata">
									<select :name="list.tagCode" @change="choosetaglist($event,index)">
										<option :value="selectempty">{{list.tagName}}</option>
										<option :value="item.tagCode" v-for="(item,d) in list.children">
											{{item.tagName}}</option>
									</select>
									
									<el-tooltip class="item smartTip-text" effect="light"  placement="top-start" v-show="list.tagName=='拿地信息'">
									       <i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
																<div   slot="content" class="list_tips" >
																	拿地面积大：拿地面积在100亩及以上的企业	<br />			
																	拿地数量多：拿地次数在三次及以上的企业			<br />		
																	有拿地：拿地面积在10亩及以上的企业				<br />	
																	近期有拿地：一年内有拿地信息的企业					<br />
																	连续拿地：两年内拿地次数有两次及以上的企业	 	<br />
																	</div> 
									    </el-tooltip>
													<el-tooltip class="item smartTip-text" effect="light"  placement="top-start" v-show="list.tagName=='专利证书'||list.tagName=='技术实力'">
													       <i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
																				<div   slot="content" class="list_tips"  > 
																					专利多：专利信息有50条及以上的企业			<br />
																					有专利：专利信息少于50条的企业			<br />
																					证书多：拥有证书10种及以上的企业			<br />
																					有证书：拥有证书少于10种的企业			<br />
																					专利质量高：发明专利占比多的企业			<br />
																					</div> 
													    </el-tooltip>
																	<el-tooltip class="item smartTip-text" effect="light"  placement="top-start" v-show="list.tagName=='股权投资信息'">
																	       <i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
																								<div   slot="content" class="list_tips"  >  
																									股权投资数量多：对外投资数10次及以上的企业				<br />
																									近期有股权投资：一年内有对外投资信息的企业	<br />			
																									有股权投资：有股权投资信息的企业				<br />
																									连续股权投资:两年内股权投资次数2次及以上的企业			<br />
																									</div> 
																	    </el-tooltip> 
									
								</div>
								<div class="selecttag" v-for="(list,index) in initialTagdata3"
									v-show="searchtype==1">
									<select :name="list.tagCode"
										@change="choosetaglist($event,initialTagdata.length+index)">
										<option :value="selectempty">{{list.tagName}}</option>
										<option :value="item.tagCode" v-for="(item,d) in list.children">
											{{item.tagName}}</option>
									</select>
								</div>
								<div class="selecttag" v-for="(list,index) in initialTagdata1"
									v-show="searchtype==2">
									<select :name="list.tagCode"
										@change="choosetaglist($event,initialTagdata.length+index)">
										<option :value="selectempty">{{list.tagName}}</option>
										<option :value="item.tagCode" v-for="(item,d) in list.children">
											{{item.tagName}}</option>
									</select>
									<el-tooltip class="item smartTip-text" effect="light"  placement="top-start"  v-show="list.tagName=='融资金额标签'">
									      <i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
															<div   slot="content" class="list_tips" >
																<p>融资金额大：单次融资金额在一亿及以上的企业</p> 
																</div> 
									   </el-tooltip>
								</div> 
								<div class="selecttag" v-for="(list,index) in initialTagdata2"
									v-show="searchtype==3"> 
									<select :name="list.tagCode"
										@change="choosetaglist($event,initialTagdata.length+index)">
										<option :value="selectempty">{{list.tagName}}</option>
										<option :value="item.tagCode" v-for="(item,d) in list.children">
											{{item.tagName}}</option>
									</select>
								
								</div>
								
							</dd>
						</dl>
						
						<dl class="opport-screen bdbe" v-show="searchtype==3" >
							<dt class="fl">企业实力</dt>
							<dd class="fl"> 
								<span v-for="(item,index) in qyslitag3"
									@click="tagcode=item.tagCode;ajaxsearchcompany(1,'tags')"
									:class="tagcode == item.tagCode ?'a-screen current' : 'a-screen'">{{item.tagName}}</span>
							</dd>
						</dl>
						<div class="notionscreen">
							<h5 class="fl">产业分类</h5>
							<div class="oh notiontitle_box fl">
								<div class="fl notionmenu_B">
									<span class="notionmenu"
										:class="notiontype == notionlist[0].value ?'current':''"
										@click="notiontype=notionlist[0].value;"
										:data="notionlist[0].value">{{notionlist[0].label}}</span>
									<el-cascader v-if="flag" :options="options1" @change="cascaderchange1"
										@visible-change="cascaderboxtoggle" :show-all-levels="false" placeholder=""
										ref="cascaderinput1" v-model="cascadervalue"
										:props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"
										collapse-tags clearable></el-cascader>
								</div>
								<div class="fl notionmenu_B">
									<span class="notionmenu"
										:class="notiontype == notionlist[1].value ?'current':''"
										@click="notiontype=notionlist[1].value;"
										:data="notionlist[1].value">{{notionlist[1].label}}</span>
									<el-cascader v-if="flag" :options="options2" @change="cascaderchange2"
										@visible-change="cascaderboxtoggle" :show-all-levels="false" placeholder=""
										ref="cascaderinput2" v-model="cascadervalue"
										:props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"
										collapse-tags clearable></el-cascader>
								</div>
								<div class="fl notionmenu_B">
									<span class="notionmenu"
										:class="notiontype == notionlist[2].value ?'current':''"
										@click="notiontype=notionlist[2].value;"
										:data="notionlist[2].value">{{notionlist[2].label}}</span>
									<el-cascader v-if="flag" :options="options3" @change="cascaderchange3"
										@visible-change="cascaderboxtoggle" :show-all-levels="false" placeholder=""
										ref="cascaderinput3" v-model="cascadervalue"
										:props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"
										collapse-tags clearable></el-cascader>
								</div>
							</div>
							<div class="fr notionbtn">
								<span class="fl determine_btn" v-show="notionbtn" @click="notionbtnfun()">确定</span>
								<span class="fl close_btn" v-show="notionbtn">关闭</span>
							</div>
						</div>
						<dl class="opport-screen bdte" v-show="usernotionlist.length>0">
							<dt class="fl">已选产业</dt>
							<dd class="fl leftlian oh">
								<span class="span-screen fl" v-for="(item,index) in usernotionlist"
									@click="deletetag(index)">{{item.name}}<i @click="ckll(item.id)" class="concept_notionlist el-icon-close" ></i></span>
									<span class="fr concept_empty" @click="emty()">清空</span>
							</dd>
						</dl>
					</div>
					 
				</div> 
			</div> 
			 <div class="whitebox">
			 	<div class="enterparise_guide oh" style="width: 95%; ">
			 		<p class="fl" v-if="!kwtextsearch">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
			 		<p class="fl" style="width: 95%; " v-if="kwtextsearch">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关企业</p>
						<div  :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" @click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0"><span>导出数据</span></div>
			 	</div> 
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg"> 
						<li class="fl" v-for="(list,index) in dimensionList" @click="tablesort(list.type);"><span 	:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span></li>
					</ul>
			 	<div class="enterprise_list_box" v-show="enterpristlist.length!=0"> 
			 		<!-- 创新企业 -->
			 		<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype1 == 2" >
			 			<tr>
								<th>排名</th>
			 				<th>企业名称</th>
			 				<th>所属产业</th>
			 				<th>画像标签</th> 
			 				<th>星级</th> 
			 				<th>融资轮次</th>
			 				<th>融资时间</th>
			 				<th>融资金额</th>
			 				<th>地区</th>
			 				<th>投资方</th>  
			 				</tr> 
			 			<tr v-for="(list,index) in enterpristlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
			 				<td class="title"  @click="routerlinkid('enterprises',list.stockCode,2,'',curindex)">{{list.title}}</td>
			 				<td class="conpanytags hastag1" v-show="list.notion!=''">
			 						<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',3,'notion',item.id,item.name,'quality2')">{{item.name}}</span> 
			 				</td> 
			 				<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
			 					<div class="" style="color: #999;">-</div>
			 				</td> 
			 				<td class="conpanytags hastag1" v-show="list.tag!=''"> 
			 						<span class="span-tag" v-for="item in list.taglist"  @click="tagrouter('/enterpriseTag',3,'tag',item.id,item.name,'quality2')">{{item.name}}</span> 
			 				</td> 
			 				<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
			 					<div class="" style="color: #999;">-</div>
			 				</td> 
			 				<td>
			 					<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0">
			 						<img src="../../assets/starfull.png" alt="" v-for="item in list.star">
			 						<img src="../../assets/star.png" alt="" v-for="item in (5-list.star)">
			 					</p>
			 					<span v-if="list.star == 0">-</span>
			 				</td> 
			 				<td  v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td> 
			 				<td  v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td> 
			 				<td  v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>  
			 				<td>{{list.area}}</td>
			 				<td class="orglist" >
			 					<p v-if="list.financingRound.length>0"><span v-for="(org,inds) in list.financingRound[0].orgList" data="org.id" :class="org.id!=0?'curp':''" @click="detailrouterto('investement-enterprises',org.id)">
			 					{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
			 					<p v-if="list.financingRound.length==0">-</p>
			 					</td>  
			 			</tr>
			 		</table>   
			 	</div> 
			 	<div class="centerpage1 company_pagelist" v-show="totalPage>1">
			 		<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
			 		</zpagenav>
			 	</div>
			 </div>
		</div>
		<div class="enlistexportPop" v-show="exportpop" >
			<div class="enlistexportPop_box"> 
				<h5 class="title">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5> 
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()" >{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</div>
</template>

<script>
	import { dataInJs } from "../../utils/city.js";
	export default {
		name: 'index',
		data() {
			return { 
				title: "创新企业",curindex:12,
				isCollapse:false,
				usernotionlistsave:[],
				islogin: false,
				userdata:{}, 
				showscreen:true, 
				notiontype:'',
				searchtype:0,
				searchtype1:2,
				searchtext:"",
				kwtextsearch:false,
				kwtextsearchtext:"",
				notionbtn:false,
				notionlist:[{label: "先进制造业",value:"A"},{label: "传统制造业",value:"B"},{label: "未来产业",value:"C"},{label: "省份城市",value:"D"},],
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList:[{name:'综合',type:0},{name:'融资时间',type:1},{name:'企业实力',type:2},{name:'投资力度',type:3},{name:'本省关联度',type:4},{name:'拿地数量',type:5},{name:'拿地面积',type:6},{name:'拿地金额',type:7},{name:'投资项目数量',type:8},{name:'投资项目金额',type:9}],
				//{name:'控制企业数量',type:10},{name:'专利数量',type:11},
				notionlist1:{},
				notionlist2:{},
				notionlist3:{},
				notionlist4:{},
				notionlist5:{},
				notionlist6:{}, 
				options:  [],
				options1:{},
				options2:{},
				options3:{},
				selectempty:'empty',
				flag:false,
				cascadervalue:"",
				usernotionlistsave:[],//用户选择的概念列表存储
				usernotionlist:[],//用户选择的概念列表
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage:1,
				maxPage:10,  //最大页数
				provincelist:[],
				provinceid:0,
				cityid:0, 
				countyid:0,
				provincedata:[],
				citydata:[], 
				countydata:[],
				initialTagdata:[{tagName:"",tagCode:"",children:[]}],
				initialTagdata1:[{tagName:"",tagCode:"",children:[]}], //创新企业
				initialTagdata2:[{tagName:"",tagCode:"",children:[]}], //优质企业
				initialTagdata3:[{tagName:"",tagCode:"",children:[]}], //龙头企业
				qyslitag1:[],
				qyslitag2:[],
				qyslitag3:[],
				qyslitag:[],
				searchtagdata:[0,0],
				enterpristlist:[],
				industrydata:[], 
				usertaglist:[],
				capitalid:0,
				typeid1:0,
				typeid2:0,
				typeid3:0,
				typeid4:0,
				typeid5:0,
				typeid6:0, 
				num:0,
				orderField:0,//排序字段 0 分数 1 时间
				orderType:0,//排序方式 0 降序 1 升序
				recapital:[
					{name:"100万以下",id:1251},
					{name:"100-1000万",id:1252},
					{name:"100-5000万",id:1253},
					{name:"5000万及以上",id:1254},
					{name:"自定义",id:1255},  
				],
				moretypedata1:{typename:"企业状态",inputname:"qiyezhuangtai",data:[{name:"aaaaaaaa",id:1351},{name:"bbbbbbbb",id:1352},{name:"cccccccccc",id:1353},{name:"dddddddddd",id:1354},]},
				tagcode:'0',
				tyinitialTagdata:[],
				areadata:dataInJs(), //省份城市数据
				exportnum:0,//导出次数
				exportpop:false,//点击导出按钮弹框显示
				allowexport:false,//后台判断是否可以上传
				exportbtn:true,//loading小 等待转圈圈
				confirmtext:'确认导出',iframeurl:'',
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', true);
		},
		created() { 
			this.$nextTick(() => {
			        // 禁用右键
			        document.oncontextmenu = new Function("event.returnValue=false");
			        // 禁用选择
			        document.onselectstart = new Function("event.returnValue=false");
			      }); 
		 var _this=this;  
			this.userdata = this.getuseriformation();
			this.searchtype=2;
			this.searchtype1=2;
			// _this.notionlist=NotionTree; 
			//三大产业概念数据
			this.$axios.get(this.$api.tag.notion.list()+'?level=5',{headers:{AuthToken:this.userdata.token}}).then(function(res){
				// console.log(res.data)
				if(res.data.success){  
					console.log(res.data.list)
					_this.notionlist=res.data.list;
					_this.options1=res.data.list[0].children;
					_this.options2=res.data.list[1].children;
					_this.options3=res.data.list[2].children;
					_this.flag=true;
					// _this.notionlist=res.data.list;  
				}else{ 
					
				} 
			}).catch(function (error) { 
				// 请求失败处理 console.log(error);
			});
			// this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
			// 	// console.log(res.data)
			// 	if(res.data.success){  
			// 		console.log(res.data)
			// 	 _this.provincedata=res.data.list; 
			// 	}else{ 
			// 		
			// 	} 
			// }).catch(function (error) { 
			// 	// 请求失败处理 console.log(error);
			// });
			this.provincedata=this.areadata;
			this.getocnapidoctaglist(2); 
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			console.log('sercatype:',this.searchtype,this.searchtype1)
			var _this = this;
			this.searchtype = this.$route.query.type *1 -1; 
		 this.pageHandler(1);   
			$('.notionmenu').click(function(){
				// console.log(51411);
				// console.log($(this).siblings('.el-cascader').html())
				$(this).siblings('.el-cascader').click(); 
				
			})
			// this.ajaxsearchcompany();
		},
		methods: { 
			ckll(id){
				console.log(id);
				var dat=this.usernotionlist;
				console.log(this.usernotionlist);
				for(var i=0;i<dat.length;i++){
					if(dat[i].id==id){ 
						this.usernotionlist.splice(i,1);  //删除对应的已选标签 
					}
				}
				console.log(this.usernotionlist);
			},
			//企业列表导出数据
			getajaxUrl(apiurl){
				var _this=this,ajaxurl='';
					//公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				 var searchtagdata1=this.searchtagdata.filter(item=>{return item!='empty'&& item!=0;});
					console.log('searchtagdata1',searchtagdata1); 
						var tagaja=_this.jsondouhao('tag',searchtagdata1);
						var	notionja=_this.jsondouhao('notion',this.usernotionlistsave);  
						var	kwaja=_this.jsondouhao('kw',this.searchtext);  
						ajaxurl=apiurl+'?type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+"&orderField="+this.orderField+"&orderType="+this.orderType;;
					// console.log('省份城市ID',this.provinceid,this.cityid);  
				return ajaxurl
			},
			enlistExport(){
				if(this.exportbtn){
					this.exportpop=true;
				} 
				console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			}, 
			
			exportlistFun(){  //下载报告
			var _this=this;
			var ajaxurl=this.getajaxUrl(this.$api.cyl.enterprise.export())+'&token='+this.userdata.token;
				this.confirmtext="导出中";
				var iframe = document.getElementById("exportIframe"); 
				iframe.setAttribute("src", ajaxurl);_this.exportnum=this.exportnum--; 
				setTimeout(()=>{
					_this.confirmtext="导出成功";_this.exportpop=false;_this.exportbtn=false;
				},5000)
				setTimeout(()=>{
					_this.exportbtn=true;_this.confirmtext="确认导出";
				 console.log('一分钟冷却计时')
				},60000)
			},
			emty(){  //清空已选概念数据
				this.usernotionlist=[];
				this.usernotionlistsave=[];
				this.ajaxsearchcompany(); 
				this.$refs['cascaderinput1'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
				this.$refs['cascaderinput2'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
				this.$refs['cascaderinput3'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
			},
			cascaderchange(value){  
				const checkedNodes = this.$refs['cascaderinput'].getCheckedNodes()
				console.log(checkedNodes) // 获取当前点击的节点
				var ddddg=[];
				for(var i=0;i<checkedNodes.length;i++){
					 ddddg.push({name:checkedNodes[i].label,id:checkedNodes[i].value})
				};
				this.usernotionlist=ddddg;
				// console.log(value); 
			}, 
			//当级联面板打开/关闭时
			cascaderboxtoggle(bool){
				// if(!bool){
				// 	this.notiontype=0;
				// }
				this.notionbtn=bool;
			},
			//当获取到值时
			cascaderchangesm(checkedns){
				var ddda=[],dddb=[],dddc=[],allddd=[];
				var dddaa=[],dddaa1=[],dddbb=[],dddbb1=[],dddcc=[],dddcc1=[],dddee=[],dddee1=[],alld=[];
				var ddtds='';
					for(var i=0;i<checkedns.length;i++){
						if(checkedns[i].level == 1){ 
							dddaa.push(checkedns[i].value);
							dddaa1.push(checkedns[i].value);
						}else if(checkedns[i].level == 2){ 
							dddbb.push(checkedns[i].value); 
							dddbb1.push(checkedns[i].value); 
						}else if(checkedns[i].level == 3){ 
							dddcc.push(checkedns[i].value); 
							dddcc1.push(checkedns[i].value); 
						}else if(checkedns[i].level == 4){ 
							dddee.push(checkedns[i].value); 
						}
						allddd.push({name:checkedns[i].label,id:checkedns[i].value});
					};  
					for (var i=0;i<dddbb.length;i++){
						let bstring=dddbb[i];
						for(var d=0;d<dddaa.length;d++){
							let astring=dddaa[d];
							if(bstring.indexOf(astring) > -1 ){
								 dddbb[i]='xs';
							} 
						} 
					};    
					for (var i=0;i<dddcc.length;i++){
						let bstring=dddcc[i];  
							for(var d=0;d<dddbb1.length;d++){
								let astring=dddbb1[d];
								if(bstring.indexOf(astring) > -1 ){
									dddcc[i]="xs";
								} 
							} 
					}; 
					for (var i=0;i<dddee.length;i++){
						let bstring=dddee[i];  
							for(var d=0;d<dddcc1.length;d++){
								let astring=dddcc1[d];
								if(bstring.indexOf(astring) > -1 ){
									dddee[i]="xs";
								} 
							} 
					};   	 
					for (var i=0;i<dddbb.length;i++){
						let bstring=dddbb[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						} 
					};
					for (var i=0;i<dddcc.length;i++){
						let bstring=dddcc[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						}
					}; 
					for (var i=0;i<dddee.length;i++){
						let bstring=dddee[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						} 
					};
					// console.log(dddaa,dddbb,dddcc,dddee);  
						var usernotionlistd=[];
					for(var a=0;a<dddaa.length;a++){
						let astring=dddaa[a];
						for(var b=0;b<allddd.length;b++){
							if(astring == allddd[b].id){
								usernotionlistd.push(allddd[b]);
							}
						}
					} 
					this.usernotionlistsave=usernotionlistd; 
			},
			cascaderchange1(value){ 
				const checkedNodes = this.$refs['cascaderinput1'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			cascaderchange2(value){
				const checkedNodes = this.$refs['cascaderinput2'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			cascaderchange3(value){
				const checkedNodes = this.$refs['cascaderinput3'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			//时间/分数升降序
			tablesort(field){
				if(field == this.orderField){
					this.orderType = Math.abs(this.orderType -1); 
				}else{
						this.orderField = field; 
				}  
				this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun(){ 
				this.searchtext=$.trim(this.searchtext); 
				// if(this.searchtext!="" || ){
				this.ajaxsearchcompany();
				// } 
			},
			searchenter(e){ 
				if(e.keyCode == 13){
					this.searchkwfun();
				}
			},
			//画像标签高级搜索
			//获取后台标签列表
			getocnapidoctaglist(type){ 
				var _this=this; 
				this.$axios.get(this.$api.tag.tag.list()+'?categoryId='+type,{headers:{AuthToken:this.userdata.token}}).then(function(res){   
					// console.log('gettagno',res.data); 
				 var tagdsta=res.data.list.filter(data=>{
						return data.children.length>0;
					})
					for(var i=0;i<tagdsta.length;i++){
						_this.searchtagdata.push('empty');
					}
					if(type == 2){ //企业通用标签
						_this.initialTagdata=tagdsta; 
						_this.tyinitialTagdata =_this.initialTagdata;
						var datalen = _this.tyinitialTagdata.length;
						_this.qyslitag = _this.initialTagdata[datalen-1].children;
						_this.qyslitag.unshift({tagName:"全部",tagCode:"0"});
						_this.getocnapidoctaglist(3); 
					}else if(type == 3){ //创新企业专属标签
						_this.initialTagdata1=tagdsta;  
						
						var ninitialTagdata=[],ndata2=[];
						for(var i=0;i<_this.tyinitialTagdata.length;i++){
							if(_this.tyinitialTagdata[i].tagName!='企业类型标签' && _this.tyinitialTagdata[i].tagName!="企业规模标签"&& _this.tyinitialTagdata[i].tagName!="上市公司供应链"&& _this.tyinitialTagdata[i].tagName!="行业概念标签"&& _this.tyinitialTagdata[i].tagName!="其他个性化标签"&& _this.tyinitialTagdata[i].tagName!="行业潜力标签"&& _this.tyinitialTagdata[i].tagName!="技术实力标签"&& _this.tyinitialTagdata[i].tagName!="区域特色标签"){
									ninitialTagdata.push(_this.tyinitialTagdata[i]);					 
									} 
									// if(_this.tyinitialTagdata[i].tagName=="区域特色标签"){
									// 	var newyzqy=[];
									// 	 var yzqy=_this.tyinitialTagdata[i].children;
									// 		for(var x=0;x<yzqy.length;x++){
									// 			if(yzqy[x].tagName!='先进院客户'){
									// 				newyzqy.push(yzqy[x]); 
									// 				_this.tyinitialTagdata[i].children=newyzqy;
									// 			}
									// 		} 
									// }
						} 
						for(var n = 0;n<_this.initialTagdata1.length;n++){
							if(_this.initialTagdata1[n].tagName !='其他个性化标签'&&_this.initialTagdata1[n].tagName !='融资轮次标签'){
								 ndata2.push(_this.initialTagdata1[n]);
							}
							
						}
						_this.initialTagdata = ninitialTagdata;
						// _this.qyslitag2 = _this.initialTagdata1[0].children; //在删除标签之前赋值，否则删除后没有值
						var qysldata = _this.initialTagdata1[0].children;
						for(var i=0;i<qysldata.length;i++){ 
							if(qysldata[i].tagName !='尚未获投'){
								_this.qyslitag2.push(qysldata[i]);
							}
						}
						_this.initialTagdata1 = ndata2;  
						_this.qyslitag2.unshift({tagName:"全部",tagCode:"0"});
					}else if(type ==10010){ //龙头企业专属标签
						_this.initialTagdata3=tagdsta;
						var ndata=[],ndata1=[],qylxtag=[],nqylxtag=[];
						for(var i=0;i<_this.tyinitialTagdata.length;i++){
							if(_this.tyinitialTagdata[i].tagName!='企业规模标签' && _this.tyinitialTagdata[i].tagName!="行业概念标签"&& _this.tyinitialTagdata[i].tagName!="其他个性化标签"&& _this.tyinitialTagdata[i].tagName!="行业潜力标签"&& _this.tyinitialTagdata[i].tagName!="上市公司供应链"&& _this.tyinitialTagdata[i].tagName!="技术实力标签"){
									ndata.push(_this.tyinitialTagdata[i]);					 
									}
									if(_this.tyinitialTagdata[i].tagName=='企业类型标签'){
										qylxtag = _this.tyinitialTagdata[i].children;
										for(var j=0;j<qylxtag.length;j++){
											if(qylxtag[j].tagName=='国有企业'||qylxtag[j].tagName=='央企'){
												nqylxtag.push(qylxtag[j]); 
											}
										}
									}
									
						}
						_this.initialTagdata[0].children = nqylxtag; 
						for(var n = 0;n<_this.initialTagdata3.length;n++){
							if(_this.initialTagdata3[n].tagName !='经营状况'&&_this.initialTagdata3[n].tagName !='企业实力标签'){
								 ndata1.push(_this.initialTagdata3[n]);
							}
						}
						_this.initialTagdata = ndata;
						_this.qyslitag1 = _this.initialTagdata3[0].children;
						_this.initialTagdata3 = ndata1; 
						_this.qyslitag1.unshift({tagName:"全部",tagCode:"0"});
					}else if(type==10009){ //优质企业专属标签
						_this.initialTagdata2=tagdsta;  
						
						var ninitialTagdata2=[],ndata3=[];
						for(var i=0;i<_this.tyinitialTagdata.length;i++){
							if(_this.tyinitialTagdata[i].tagName!='企业类型标签' && _this.tyinitialTagdata[i].tagName!="企业规模标签"&& _this.tyinitialTagdata[i].tagName!="行业概念标签"&& _this.tyinitialTagdata[i].tagName!="其他个性化标签"&& _this.tyinitialTagdata[i].tagName!="技术实力标签"&& _this.tyinitialTagdata[i].tagName!="行业潜力标签"){
									ninitialTagdata2.push(_this.tyinitialTagdata[i]);					 
									} 
						}  
						
						for(var n = 0;n<_this.initialTagdata2.length;n++){
							if(_this.initialTagdata2[n].tagName !='企业实力标签'&&_this.initialTagdata2[n].tagName !='行业潜力标签'){
								 ndata3.push(_this.initialTagdata2[n]);
							}
						}
						_this.initialTagdata = ninitialTagdata2;  
						_this.qyslitag3 = _this.initialTagdata2[0].children; //在删除标签之前赋值，否则删除后没有值
						_this.initialTagdata2 = ndata3;
				_this.qyslitag3.unshift({tagName:"全部",tagCode:"0"});
					}
					// console.log(tagdsta,_this.searchtagdata);
				}); 
			},  
			//选择标签
			choosetaglist(obj,index){
				console.log(obj.target.value,this.initialTagdata.length,index+1);
				this.searchtagdata[index+2]=obj.target.value;
			 this.ajaxsearchcompany(); 
			},
			detailrouterto(path,id,type){
				let routeUrl = this.$router.resolve({
						path: path,query: {type:type,id:id}
				});
				window.open(routeUrl.href, '_blank');  
			}, 
			pageHandler: function (page) { 
				this.page = page; 
				this.ajaxsearchcompany(page); 
			},
			//省份城市选择
			 provincechoose(id,i){ 
					this.provinceid =id;this.cityid =0; this.countyid =0;
					this.countydata=[];
					if(i!="all" && this.provincedata[i].children != null){
							this.citydata=this.provincedata[i].children;
					}else{
						this.citydata=[];
					} 
					this.page=1; 
					this.ajaxsearchcompany();
				},
				choosecity(id,i){
					//	console.log('choosecity',id);
					this.cityid =id;this.countyid =0;
					if(i!="all" && this.citydata[i].children!= null){
							this.countydata=this.citydata[i].children;
					}else{
						this.countydata=[];
					} 
					this.page=1; 
					this.ajaxsearchcompany(); 
				}, 
				choosecounty(id){
					//	console.log('choosecity',id);
					this.countyid =id;
					this.page=1; 
					this.ajaxsearchcompany();
				}, 
				//删除标签
				deletetag(ind){
					this.usertaglist=this.usertaglist.filter(function(item,index){
						return index!=ind;
					});
					this.page=1;
					this.ajaxsearchcompany(); 
					if(this.usertaglist.length == 0){
						this.showscreen=true;
					}
				}, 
				notionbtnfun(){ 
					this.usernotionlist=this.usernotionlistsave; 
					// this.searchtext="";
					this.ajaxsearchcompany();  
				},
				//字符串拼接
				jsondouhao(name,data){
					var notionja="",douhao='%2C'; 
					if(data.length>0){ 
						if(name == "kw"){
								notionja=data;
						}else{
							for(var i=0;i<data.length;i++){
								if(i==data.length-1){
									douhao='';
								}
								if(name == 'tag'){
									notionja+=data[i]+douhao;
								}else if(name == "notion"){
									notionja+=data[i].id+douhao;
								}  
							}
						} 
						notionja='&'+name+'='+notionja; 
					}  
					return notionja;
				},  
				ajaxsearchcompany(pages,type){ 
				this.bus.$emit('loading',true); 
				var ajpage=1;
				if(pages){
					ajpage=pages;
				}
				this.page=ajpage;
				var _this=this;
					// //公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				 // var searchtagdata1=this.searchtagdata.filter(item=>{return item!='empty'}); 
					// if( _this.tagcode !=0  && searchtagdata1.length<=0){ 
					// 	var tagaja='&tag='+_this.tagcode;
					// 	var ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+tagaja+'&page='+ajpage;
					// }else{
					// 	var tagaja=_this.jsondouhao('tag',searchtagdata1);
					// 	var	notionja=_this.jsondouhao('notion',this.usernotionlistsave);  
					// 	var	kwaja=_this.jsondouhao('kw',this.searchtext);  
					// 	var ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+'&page='+ajpage;
					// }   
					// if(_this.searchtype == 2){
					// 	ajaxurl+="&orderField="+this.orderField+"&orderType="+this.orderType;
					// } 
					var ajaxurl=this.getajaxUrl(this.$api.cyl.enterprise.list())+'&page='+ajpage;
					console.log(ajaxurl)
					this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log('企业列表',res.data) ;
						if(res.data.success){  
								_this.exportnum=res.data.extend.exportRemainder;
						_this.enterpristlist=res.data.list; 
							if(_this.searchtype == 1 || _this.searchtype == 2){
								//大小企业 
							}else if(_this.searchtype == 5){
								//机构列表 
							} 
							for(var i=0;i<res.data.list.length;i++){
								_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
								_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode); 
									//创新企业专属
								if(_this.searchtype==2  && _this.enterpristlist[i].financingRound == null){
									_this.enterpristlist[i].financingRound=[];
								}
							} 
							_this.bus.$emit('loading',false); 
							_this.totalPage=res.data.totalPage;
							_this.pageSize=res.data.pageSize;  
							_this.total=res.data.totalRecord; 
							_this.haspage=res.data.list.length  == res.data.pageSize; 
							_this.searchtype1=_this.searchtype;  
							_this.kwtextsearch=_this.searchtext!=""; 
							_this.kwtextsearchtext=_this.searchtext;
								_this.exportbtn=true;_this.confirmtext="确认导出"; 
						}else{ 
							
						} 
					}).catch(function (error) {}); 
				// console.log(datas);  
			}
		}
		}
</script>

<style> 
</style>
